import { useClaimant } from '../context/col'

/**
 * Hook zjistí, zda je vytvoren CaseReport z kontextu aplikace.
 *
 * @returns
 */
function useCaseReportIsPresent(): boolean {
  const { state } = useClaimant()
  // return state.loadedCaseReportResp != null
  return state.caseReportId != null
}

export default useCaseReportIsPresent
